// extracted by mini-css-extract-plugin
export default {"Logo":"Logo_Logo__mb7V1","Logo__Text":"Logo_Logo__Text__+91wi"};